import PropTypes from 'prop-types';
import React from 'react';
import Flexbox from 'flexbox-react';
import Select from 'react-select';
import Creatable from 'react-select/lib/Creatable';

/**
 * A simple form that lets you prompt for the name of a new entity.  The name can be either a single input
 * or a select combo box.
 */
export default class NewEntityForm extends React.Component {
    static propTypes = {
        value: PropTypes.any,
        options: PropTypes.array,
        multi: PropTypes.bool,
        creatable: PropTypes.bool,
        title: PropTypes.string,
        inputLabel: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = {
            value: null
        };
    }

    promptTextCreator = (label) => {
        return `Select custom value: ${label}`;
    };

    onSelectChange = (value) => {
        this.setState({ value });
    };

    onInputChange = (e) => {
        this.setState({ value: e.target.value });
    };

    getNewName = () => {
        const value = this.state.value;
        let newName = null;
        if (typeof value === 'string') {
            newName = value;

        } else if (Array.isArray(value)) {
            newName = value.map(valueObject => {
                return valueObject.value;
            });

        } else if (value !== null) {
            newName = value.value;
        }
        return newName;
    };

    setInvalid = (errorMessage) => {
        this.setState({ invalid: true, errorMessage });
    };

    isNil(value) {
        if (value === null || typeof value === 'undefined') {
            return true;
        }
        return false;
    }

    render() {
        const newItemNameRefFunction = (component) => {this.newItemNameComponent = component;};
        const errorMessageRefFunction = (component) => {this.errorMessageComponent = component;};
        let value = '';
        if (!this.isNil(this.state.value)) {
            value = this.state.value;

        } else if (!this.isNil(this.props.value)) {
            value = this.props.value;
        }
        const className = this.state.invalid ? 'invalid' : '';

        let form = null;
        if (this.props.options) {
            let selectComponent = null;

            if (this.props.creatable) {
                selectComponent = (
                    <Creatable
                        ref={newItemNameRefFunction}
                        classNamePrefix="react-select"
                        value={value}
                        options={this.props.options}
                        onChange={this.onSelectChange}
                        promptTextCreator={this.promptTextCreator}
                        autoFocus
                        isMulti={this.props.multi}
                        isClearable
                    />
                );
            } else {
                selectComponent = (
                    <Select
                        ref={newItemNameRefFunction}
                        classNamePrefix="react-select"
                        value={value}
                        options={this.props.options}
                        onChange={this.onSelectChange}
                        autoFocus
                        isMulti={this.props.multi}
                        isClearable
                    />
                );
            }
            form = (
                <Flexbox alignItems="center" flexDirection="row">
                    <div>{this.props.inputLabel}:</div>
                    <div style={ { flexGrow: 1, marginLeft: '5px' } }>
                        {selectComponent}
                    </div>
                </Flexbox>
            );
        } else {

            form = (
                <Flexbox alignItems="baseline" flexDirection="row">
                    <div>{this.props.inputLabel}:</div>
                    <input
                        ref={newItemNameRefFunction}
                        className={className}
                        style={ { flexGrow: 1, marginLeft: '5px' } }
                        onChange={this.onInputChange}
                        value={value}
                        autoFocus
                    />
                </Flexbox>
            );
        }
        return (
            <Flexbox flexDirection="column" className="new-entity-form">
                {form}
                <div className={className} style={ { marginTop: '15px' } } ref={errorMessageRefFunction}>
                    {this.state.errorMessage}
                </div>
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/forms/NewEntityForm.js